'use strict';

// @TODO update newsletter logic to match the one from newsletter.js script (used for all newsletter subscription forms)

/**
 * @description Initialize event handlers on landing page
 */

window.addEventListener('mainJsLoaded', function () {
    bespokeInit();
});

function bespokeInit() {
    // bespoke mobile nav init
    var $bespokeAriaParent = $('.js-bespokeDropdownControl'),
        $bespokeAriaControl = $('#' + $bespokeAriaParent.attr('aria-controls')),
        $openBespokeDropdownBtn = $('.js-bespokeLinksControlButton'),
        $bespokeAnchorLinks = $('.js-bespokeAnchorLink'),
        isBespokeDropdownActive = false;

    $openBespokeDropdownBtn.on('click keydown', function (e) {
        // mouse click or keyboard control using enter/space key
        if (e.type == 'click' || (e.type == 'keydown' && (e.keyCode == 13 || e.keyCode == 32))) {
            // prevent the default action to stop scrolling when space is pressed
            e.preventDefault();

            isBespokeDropdownActive = $bespokeAriaControl.attr('aria-expanded') == 'true' ? false : true;
            $bespokeAriaControl.attr('aria-expanded', isBespokeDropdownActive ? 'true' : 'false').attr('aria-hidden', isBespokeDropdownActive ? 'false' : 'true');
            if (isBespokeDropdownActive) {
                $bespokeAriaParent.addClass('opened');
            } else {
                $bespokeAriaParent.removeClass('opened');
            }
        }
    });

    $bespokeAnchorLinks.on('click keydown', function (e) {
        // mouse click or enter key
        if (e.type == 'click' || (e.type == 'keydown' && e.keyCode == 13)) {
            $bespokeAriaParent.removeClass('opened');
            $bespokeAriaControl.attr('aria-expanded', 'false').attr('aria-hidden', 'true');
        }
    });

    var $form = $('#bespokeForm');

    $('.js-projectHospitality').click(function () {
        $('#js-yourproject').val('HOSPITALITY');
    });

    $('.js-projectCorporate').click(function () {
        $('#js-yourproject').val('CORPORATE GIFTING');
    });

    $('.js-projectMeasure').click(function () {
        $('#js-yourproject').val('MADE TO MEASURE');
    });

    $('#js-phoneCountry').val(window.vbq.localizationData.countryCode);
    window.vbqUtils.phoneCodes.init($('#js-phoneCountry'), $('.js-form-phone'));

    $form.validate(); //required before adding rule
    window.vbqUtils.validationLogic.formValidation($form);
}
